import { ChangeDetectorRef, Component, ComponentFactoryResolver, ElementRef, EventEmitter, NgZone, OnInit, Output, TemplateRef, ViewChild, ViewContainerRef } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { from, Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { PersonSearchService } from 'src/app/_services/person-search.service';
import { MatAutocompleteTrigger as MatAutocompleteTrigger } from '@angular/material/autocomplete';
import * as _ from 'underscore';
import { FreemiumService } from '../../webtree-website/freemium.service';
import { FreemiumJdData, FreemiumParams } from '../../webtree-website/freemiumParams';
import { SearchtoolboxService } from 'src/app/_services/searchtoolbox.service';
import { TextExtractResponse } from 'src/app/common-interfaces-classes/TextEtractResponse';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { WebbtreeJdSearchFilterModalComponent } from '../../webtree-website/webbtree-jd-search-filter-modal/webbtree-jd-search-filter-modal.component';
import { GenAiLoaderComponent } from '../../webtree-website/gen-ai-loader/gen-ai-loader.component';
import { FreemiumConstants } from '../../webtree-website/freemiumConstants';
import { FreemiumAPIService } from '../../webtree-website/freemium-api.service';
import { GaEventsService } from 'src/app/_services/ga-events.service';
import { ViewportScroller } from '@angular/common';
import { InsightsProfileSectionComponent } from '../../webtree-website/insights-profile-section/insights-profile-section.component';
import { SevenDayFreeTrialFormComponent } from '../../webtree-website/seven-day-free-trial-form/seven-day-free-trial-form.component';
import { SevenDayFreeTrialModalComponent } from '../../webtree-website/seven-day-free-trial-modal/seven-day-free-trial-modal.component';
import { SkilltaxonomyLoaderComponent } from '../skilltaxonomy-loader/skilltaxonomy-loader.component';
import { MarketingModalComponent } from '../marketing-modal/marketing-modal.component';
import { Router } from '@angular/router';



@Component({
    selector: 'app-skills-taxonomy',
    templateUrl: './skills-taxonomy.component.html',
    styleUrls: ['./skills-taxonomy.component.scss'],
    standalone: false
})
export class SkillsTaxonomyComponent implements OnInit {
 private typeAheadSubject = new Subject<{ event: Event, type: string }>();
  @ViewChild(MatAutocompleteTrigger) autocomplete: MatAutocompleteTrigger;

  jobTitleInput: UntypedFormControl = new UntypedFormControl(null);
  jobTitleList: any[] = [];
  jobTitleSelectedList: any[] = [];
  filterData: FreemiumParams;
  showInsights: boolean = false;
  showregion: string = 'asia';
  skillInput: UntypedFormControl = new UntypedFormControl(null);
  skillTitleList: any[] = [];
  skillsSelectedList: any[] = [];
  locationInput: UntypedFormControl = new UntypedFormControl(null);
  locationTitleList: any[] = [];
  locationSelectedList: any[] = [];

  incorrectFileFormat: boolean = false;
  specialCharaterError: boolean = false;
  uploadedFilename: string;
  isUploadedFileCorrect: boolean = false;
  showJDNotAddedError: boolean = false;
  enteredJobDescription: string;
  uploadedFile: any = undefined;
  disableManualJDInput: boolean = false;
  fileSizeLimitExceeded: boolean = false;
  jdDataLoading: Boolean = false;
  textExtractionError = false;
  textExtractionErrorMessage: string;
  tabName: string;

  // Typeahead Ahead Loader
  jobtitleLoader: boolean = false;
  skillsLoader: boolean = false;
  locationsLoader: boolean = false;
  showQuickSearchLoader: boolean = false;
  @ViewChild('container', { read: ViewContainerRef }) container!: ViewContainerRef;
  @ViewChild('freeContainer', { read: ViewContainerRef }) freeContainer!: ViewContainerRef;
  showSkillsTaxonomyLoader:boolean=false
  jdSendToModal:any
  skillTaxonmoyPayload: any = [];
  taxonomyGraphSection:boolean=false
  showFreeTrialLoader: Boolean = false;
  showSkillSpinloader:boolean = false
  sendMeassageInEmail:any
  freeTrialForm: UntypedFormGroup = new UntypedFormGroup({
    workEmail: new UntypedFormControl(null, Validators.compose([Validators.required, Validators.pattern('^[_a-z0-9]+(\.[_a-z0-9]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,4})$')])),
  })
showErrorMsg: string;
  @ViewChild("freeTrialSuccess")
  freeTrialSuccess: TemplateRef<NgbModalRef>;
  response: any;
  jdResponse:any;
  showTaxonomyErrorMsg: boolean = false;
  constructor(private personSearchService: PersonSearchService, private freemiumService: FreemiumService, private searchtoolbox: SearchtoolboxService, private modalService: NgbModal,
    private freemiumApiService: FreemiumAPIService, private gaService: GaEventsService,private viewportScroller: ViewportScroller, private ngZone: NgZone, private cd: ChangeDetectorRef, private resolver: ComponentFactoryResolver, private router: Router) {
    this.filterData = freemiumService.fetchQuickSearchData;
  }
  @ViewChild('contentRef') contentRef: ElementRef;
  @ViewChild('contentUpgrade') contentUpgrade: ElementRef;
  @ViewChild('contentLoadRef') contentLoadRef: ElementRef;
  domainList:any[] =  FreemiumService.invalid_workemail_domain_list;
  skilltaxonomyData:any[]
  jdFilterDataToSendAPI: any
  ngOnInit() {
   let body = document.getElementsByTagName('body')[0];
    body.classList.add('bg-white');
    const typeaheadSub = this.typeAheadSubject.pipe(debounceTime(500)).subscribe(({ event, type }) => {
      this.callTypeAheadSearch(event, type);
    });

    this.freeTrialForm.get('workEmail').valueChanges.subscribe(res=>{
      if(res) {
        const invaliEmail = this.domainList.filter(x=>res.includes(x));
        if(invaliEmail.length > 0) {
          this.freeTrialForm.get('workEmail').setErrors({'invaliDomain': true});
        } else {
          this.freeTrialForm.get('workEmail').setErrors(null, {emitEvent: false});
        }
      }else{
        this.showErrorMsg = ''
      }
    })
  }
  receiveFromChild(value: any) {
    if(value.status == 'close'){
      this.showTaxonomyErrorMsg = false;
      if(value.data == null) {
        this.showTaxonomyErrorMsg = true;
      }
      this.showSkillsTaxonomyLoader = false;
      this.taxonomyGraphSection = true
      this.skilltaxonomyData = value.data
      this.sendMeassageInEmail= value.message

       this.skillTaxonmoyPayload = {
          chart: {
            bgAlpha: "0",         // makes background fully transparent
            showCanvasBg: "0",    // hides the canvas background
            caption: "Tap on the chart to access a comprehensive breakdown of the skill taxonomy by skill.",
            captionFont: "Poppins",
            captionFontSize: "14",
            captionFontColor: "#484b59",
            captionAlignment: "center", // or "left"
            captionPadding: "15",
            canvasBgAlpha: "0",   // ensures canvas background is transparent too
            showPlotBorder: "1",
            baseFontColor: "#484b59",
            tooltipcolor: "#484b59",
            innerRadius: "20",
            theme: "gammel",
            showBorder: "0",
            showLegend: "1",
            opacity:'0.1',
            paletteColors: ['#FFE3C4','#A3A3F7','#95E1D3'],
            legendPosition: "bottom", // or "right"
            showLabels: "1",
            legendItemFont: "Poppins",

            labelFontSize: "12",
            labelFontColor: "#484b59",
            labelFontBold: "1",
            labelFont: "Poppins",
            toolTipFont: "Poppins",
            toolTipFontSize: "14",
            toolTipBorderColor: "ffffff",
            toolTipPadding: "5",
          },
          data: this.skilltaxonomyData
      };
    }
    else{
      console.log(value.data,'data')

    }
  }
  onTypeAheadSearch(event: Event, type: string) {
    this.typeAheadSubject.next({ event, type });
  }

  callTypeAheadSearch(event, type) {

    const searchValue = (event.target as HTMLInputElement).value.trim();
    switch (type) {

      case 'jobtitle': {
        this.jobtitleLoader = true;
        this.freemiumApiService.getFreemiumPersonSearchListing(searchValue, 'jobtitle', this.showregion).subscribe((response: any) => {
          if (response.status == 'success' && response.data) {
            this.jobtitleLoader = false;
            this.jobTitleList = response.data;
          } else {
            this.jobtitleLoader = false;
          }
        });
        break;
      }
      case 'skill': {
        this.skillsLoader = true;
        this.freemiumApiService.getFreemiumPersonSearchListing(searchValue, 'skill', this.showregion).subscribe((response: any) => {
          if (response.status == 'success' && response.data) {
            this.skillsLoader = false;
            this.skillTitleList = response.data;
          } else {
            this.skillsLoader = false;
          }
        });
        break;
      }
      case 'location': {
        this.locationsLoader = true;
        this.freemiumApiService.getFreemiumPersonSearchListing(searchValue, 'location', this.showregion).subscribe((response: any) => {
          if (response.status == 'success' && response.data) {
            this.locationsLoader = false;
            this.locationTitleList = response.data;
          } else {
            this.locationsLoader = false;
          }
        });
        break;
      }
    }

  }

  selectedItem(event, type) {
    const inputElements: NodeListOf<Element> = document.querySelectorAll(".mat-input-element");
    inputElements.forEach((element: Element) => {
      (element as HTMLInputElement).blur();
    });
    switch (type) {
      case "jobtitle": {
        this.jobTitleList = []
        if (event.option && event.option.value) {
          this.jobTitleSelectedList.push({
            key: event.option.value.key + ".searchastext",
            chipkey: event.option.value.key
          });
        } else {
          this.jobTitleSelectedList.push({
            key: event.target.value + ".searchastext",
            chipkey: event.target.value
          });
          this.autocomplete.closePanel();
        }

        this.jobTitleSelectedList = _.uniq(this.jobTitleSelectedList, "key");
        this.jobTitleInput.reset();
        break;
      }
      case "skill": {
        this.skillTitleList = []
        if (event.option && event.option.value) {
          this.skillsSelectedList.push({
            ...event.option.value,
            chipkey: event.option.value.key
          });
        } else {
          this.skillsSelectedList.push({
            key: event.target.value + ".searchastext",
            chipkey: event.target.value
          });
          this.autocomplete.closePanel();
        }

        this.skillsSelectedList = _.uniq(this.skillsSelectedList, "key");
        this.skillInput.reset();
        break;
      }
      case "location": {
        this.locationTitleList = []
        if (event.option && event.option.value) {
          this.locationSelectedList.push({
            ...event.option.value,
            chipkey: event.option.value.key
          });
        } else {
          this.locationSelectedList.push({
            key: event.target.value + ".searchastext",
            chipkey: event.target.value
          });
          this.autocomplete.closePanel();
        }

        this.locationSelectedList = _.uniq(this.locationSelectedList, "key");
        this.locationInput.reset();
        break;
      }
    }
  }


  sendDatatoInsights(value:string) {

    this.showInsights = false;
    this.showQuickSearchLoader = false;
     if(value == 'uploadjd'){
    if(this.enteredJobDescription) {
          this.tabName = FreemiumConstants.REDIRECT_SOURCES.JOB_DESCRIPTION;
          // this.getJDKeywordsAI(this.enteredJobDescription);
          this.showSkillSpinloader= true
          this.freemiumApiService.freemiumParseJobDescription(this.enteredJobDescription).subscribe((res: FreemiumJdData) => {
            this.jdResponse = res;
            const jdFilterObj = this.freemiumService.getDataReadyForJD(this.jdResponse);
            //  this.freemiumService.setFilterModalData(jdFilterObj);
    // const filterData = this.freemiumService.fetchQuickSearchData;
          this.jdFilterDataToSendAPI = {
            jobtitle:jdFilterObj.jobtitle,
            company:jdFilterObj.company,
            skills:jdFilterObj.skills,
            location:jdFilterObj.location
          }
              const request = this.freemiumService.getRequestWithFilters();

        // if(this.tabname == FreemiumConstants.REDIRECT_SOURCES.JOB_DESCRIPTION) {
          request.job_description_keys = this.freemiumService.getFreemiumJdKeys(this.jdFilterDataToSendAPI);
          this.filterData.job_description_keys = request.job_description_keys;

        // }
        // this.filterData.continentstobeincluded = [this.showregion];
        this.freemiumService.setQuickSearchData(this.filterData);
              this.showSkillsTaxonomyLoader = true
              if(this.showSkillsTaxonomyLoader == true){
                this.showSkillSpinloader = false
              }

        });


              /**
         * GA tracking for get insights button click
         */
        this.gaService.trackButtonClick('View_skill_Taxonomy_From_JD');
        }
    }else if(value == 'quick'){

    // }
    // else {
      this.filterData.jobTitleSelectedList = this.jobTitleSelectedList;
      this.filterData.skillsSelectedList = this.skillsSelectedList;
      this.filterData.continentstobeincluded = [this.showregion];
      this.filterData.locationSelectedList = this.locationSelectedList;

      this.freemiumService.setQuickSearchData(this.filterData);
      this.tabName = FreemiumConstants.REDIRECT_SOURCES.QUICK_SEARCH;

      // this.freemiumService.changensightsProfileSection({showInsights: true, tabName: FreemiumConstants.REDIRECT_SOURCES.QUICK_SEARCH});
      // this.freemiumService.getPersonSearchRecommendForFreemium();
      // this.showQuickSearchLoader = false;
      // this.showInsights = true;
      // this.loadSelector();
      this.jdSendToModal = this.filterData
      this.showSkillsTaxonomyLoader = true
    }
    /**
     * GA tracking for get insights button click
     */
      this.gaService.trackButtonClick('View_skill_Taxonomy_From_Quick_Search');
    }




  removeChip(value, type) {
    const inputElements: NodeListOf<Element> = document.querySelectorAll('.mat-input-element');
    inputElements.forEach((element: Element) => {
      (element as HTMLInputElement).blur();
    });
    switch (type) {
      case 'jobtitle':
        this.jobTitleSelectedList = this.jobTitleSelectedList.filter(item => item.key !== value.key);
        break;
      case 'skill':
        this.skillsSelectedList = this.skillsSelectedList.filter(item => item.key !== value.key);
        break;
        case 'location':
          this.locationSelectedList = this.locationSelectedList.filter(item => item.key !== value.key);
          break;
    }
  }

  selectRegion(region) {
    this.showregion = region;
    this.locationSelectedList =[];
  }

  uploadFile(event) {
    this.uploadedFile = event.target.files[0];
    this.validateInputFile();

    if (this.uploadedFile && !this.specialCharaterError && !this.incorrectFileFormat && !this.fileSizeLimitExceeded) {
      this.isUploadedFileCorrect = true;
      this.uploadedFilename = this.uploadedFile.name;
      this.jdDataLoading = true;
      this.freemiumApiService.freemiumDocumentToText(this.uploadedFile).subscribe((response: TextExtractResponse) => {
        this.jdDataLoading = false;
        this.processTextractResponse(response);
      }, () => this.jdDataLoading = false);
    }
    /**
     * GA event for Upload JD
     */
     this.gaService.trackButtonClick('Upload_JD');
    }

  private validateInputFile() {
    this.specialCharaterError = false;
    this.incorrectFileFormat = false;
    this.fileSizeLimitExceeded = false;
    this.isUploadedFileCorrect = false;
    const validFileExtensions = ['doc', 'docx', 'pdf', 'txt', 'odt'];
    const uploadedFileExtension = this.uploadedFile.name.split('.')[1];
    const filenameRegex = /[!@#$%^&*()+\=\[\]{};':"\\|,.<>\/?]/;

    if (!validFileExtensions.includes(uploadedFileExtension.toLowerCase())) {
      this.incorrectFileFormat = true;
    }
    if (filenameRegex.test(this.uploadedFile.name.split(".")[0])) {
      this.specialCharaterError = true;
    }
    // Verify file size (File size cannot exceed 5 MB)
    if (this.uploadedFile.size > 5242880) {
      this.fileSizeLimitExceeded = true;
    }
  }

  private processTextractResponse(response: TextExtractResponse) {
    if (response.status === "success") {
      this.enteredJobDescription = response.text;
      this.textExtractionError = false;
      this.textExtractionErrorMessage = null;


    }
    else if (response.status === "failure") {
      this.textExtractionError = true;
      this.textExtractionError = true;
      this.textExtractionErrorMessage = response.message;
    }
  }

  resetFormFields() {
    this.incorrectFileFormat = false;
    this.specialCharaterError = false;
    this.isUploadedFileCorrect = false;
    this.uploadedFilename = null;
    this.fileSizeLimitExceeded = false;
    this.enteredJobDescription = "";
    this.uploadedFile = undefined;
  }

  private getJDKeywordsAI(description: string = null) {
    this.jdSendToModal = description
    let jdResponse:FreemiumJdData;
    this.showSkillsTaxonomyLoader = true
    const modalRef = this.modalService.open(
      GenAiLoaderComponent,
      { windowClass: 'genAimodal', centered: true, backdrop: 'static', keyboard: false }
    );
    // const modalInstance: GenAiLoaderComponent = modalRef.componentInstance;
    // modalInstance.description = description;

      const modalResult$ = from(modalRef.result);
      modalResult$.subscribe((response: FreemiumJdData) => {response && this.freemiumService.emitFreemiumJDDataEvent(response);
      jdResponse = response;
      const filterModalRef =  this.modalService.open(WebbtreeJdSearchFilterModalComponent, {size: 'lg',windowClass: 'modal-size', centered: true, backdrop: 'static', keyboard: false });
      filterModalRef.componentInstance.jdResponse = jdResponse;
      filterModalRef.componentInstance.tabname = FreemiumConstants.REDIRECT_SOURCES.JOB_DESCRIPTION;
      const jdFilterObj = this.freemiumService.getDataReadyForJD(jdResponse);
      this.freemiumService.setFilterModalData(jdFilterObj);
      filterModalRef.result.then(res=>{
        this.freemiumService.changensightsProfileSection({showInsights: true, tabName: FreemiumConstants.REDIRECT_SOURCES.JOB_DESCRIPTION});
        this.freemiumService.getPersonSearchRecommendForFreemium();
        this.loadSelector();


      })

      filterModalRef.componentInstance.updateModalFilterEvent.subscribe(res=>{
        if(res.type == "scroll"){
          filterModalRef.dismiss();
          this.openFreeTrial(res.eventName);

        }
      })
    });
  }

  ngOnDestroy() {
    this.freemiumService.resetFreemium();

  }

  onTabChange(type) {
    if(type == 'jd') {
      this.jobTitleInput.reset();
      this.skillInput.reset();
      this.locationInput.reset();
      this.jobTitleSelectedList = [];
      this.skillsSelectedList = [];
      this.locationSelectedList = [];
      this.showregion = 'asia';
      this.freemiumService.resetFreemium();


    } else {
      this.freemiumService.resetFreemium();
      this.enteredJobDescription = '';
      this.uploadedFilename = null;
      this.isUploadedFileCorrect=false;

    }
    this.showInsights = false;
  }

  openFreeTrial(eventName: string) {
    const elementY = this.contentUpgrade.nativeElement.offsetTop;

    // this.viewportScroller.scrollToPosition([0, elementY]);
    // this.contentUpgrade.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
    /**
     * GA event for Open Free Trial
     */
    const modalRef =  this.modalService.open(SevenDayFreeTrialModalComponent, { windowClass: 'day-trail-model', backdrop: 'static', centered: true })
  }

  get isFreemiumDescriptionEmpty() {
    return !this.enteredJobDescription || this.enteredJobDescription?.toString()?.trim()?.length === 0;
  }

  get isFreemiumQuickSearchEmpty() {
    return this.jobTitleSelectedList.length === 0 && this.skillsSelectedList.length === 0 && this.locationSelectedList.length === 0;
  }

  loadSelector() {
    const factory = this.resolver.resolveComponentFactory(InsightsProfileSectionComponent);
    this.container.clear(); // Clear previous component (if any)
    const componentRef =   this.container.createComponent(factory);
    componentRef.instance.tabname = this.tabName;

    setTimeout(() => {
      const elementY = componentRef.location.nativeElement.offsetTop;
      this.viewportScroller.scrollToPosition([0, elementY]);
    })
  }

  loadFreeTrialModal() {
    const factory = this.resolver.resolveComponentFactory(SevenDayFreeTrialFormComponent);
    this.freeContainer.clear(); // Clear previous component (if any)
    const componentRef =   this.freeContainer.createComponent(factory);
  }
  taxonomyModal(){
    const modalRef =  this.modalService.open(MarketingModalComponent, { windowClass: 'day-trail-model', backdrop: 'static', centered: true })
    modalRef.componentInstance.message = this.sendMeassageInEmail;
    this.gaService.trackButtonClick('Open_skill_Taxonomy_Modal');

  }
  requestFreeTrial() {
    this.showErrorMsg = null;

    if(this.freeTrialForm.valid) {
      this.showFreeTrialLoader = true;

      const request = {
        workemail: this.freeTrialForm.getRawValue().workEmail,
        source : 'skills-taxonomy-free-trial'
      }
      this.freemiumApiService.freeTrialRegistration(request).subscribe((res:any) => {
        this.response = res;
        this.showFreeTrialLoader = false;

        if(this.response && this.response.status == "success") {
          const modalRef = this.modalService.open(this.freeTrialSuccess, {
            size: "modal-free-trial-success",
            centered: true,
            backdrop: "static",
            keyboard: false,
          });
          this.freeTrialForm.reset();
      /**
     * GA tracking for Insights page visit
     */
    this.gaService.trackButtonClick('Free_Trial_Regitration_One');

    }
       }, (error:any)=>{
        this.showFreeTrialLoader = false;

        if(error.status == 400 && error.error.message == "Free trial request already submitted")
          this.showErrorMsg = "Free trial request already submitted";
        else if(error.status == 400 && error.error.message == "User already exists")
           this.showErrorMsg = "User already exists";
        else if(error.status == 400 && error.error.message == "Invalid work email")
          this.showErrorMsg = "Invalid work email";
             /**
     * GA tracking for Insights page visit
     */
        this.gaService.trackButtonClick('Free_Trial_Regitration_One_Error');


            })
    }



  }

  refreshComponent() {
    this.skillTaxonmoyPayload = []
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
    this.router.navigate(['/skills-taxonomy-free-trial']);
  });
}
}
